import { Injectable } from "@angular/core";
import { Role } from "../models/role.model";
import { Permission } from "../models/permission.model";
import { AuthService } from "./auth.service";
import { MvcAreaInfo } from "../models/mvccontrollerInfo.model";
import { UserRole } from "../models/user-role.model";

export type RolesChangedOperation = "add" | "delete" | "modify";
export type RolesChangedEventArg = { roles: UserRole[] | any[]; operation: RolesChangedOperation };
@Injectable()
export class AccountService {
  public static readonly roleAddedOperation: RolesChangedOperation = "add";
  public static readonly roleDeletedOperation: RolesChangedOperation = "delete";
  public static readonly roleModifiedOperation: RolesChangedOperation = "modify";

  constructor(public authService: AuthService) {}

  userHasPermission(controllerName: string, actionName: string): boolean {
    if (!this.authService.getIsLoggedIn() || !controllerName) return false;
    let controller = controllerName.indexOf("/") !== -1 ? controllerName.substring(0, controllerName.indexOf("/")) : controllerName;
    let actionId = `${controllerName}:${actionName}`;
    if (actionName === Permission.samePermission && controllerName.indexOf("/") != -1) {
      actionId = `${controller}:${controllerName.substring(controllerName.indexOf("/") + 1, controllerName.length)}`;
    }
    let createactionId = `${controller}:${Permission.createPermission}`;
    let editactionId = `${controller}:${Permission.editPermission}`;
    let deleteactionId = `${controller}:${Permission.deletePermission}`;
    let viewactionId = actionName !== Permission.viewPermission ? undefined : `${controller}:${Permission.viewPermission}`;
    if (actionName !== Permission.managePermission) {
      createactionId = undefined;
      editactionId = undefined;
    }
    if (actionName !== Permission.deletePermission) {
      deleteactionId = undefined;
    }
    let userName = this.authService.currentUser.UserName;
    let isOk = false;
    let roles: Role[];
    let index: number = 0;
    while (!isOk) {
      const x = this.authService.userRoles(userName);
      if (x && x.length > 0) {
        isOk = true;
        roles = x.filter((x) => x.UserName.toUpperCase() === userName.toUpperCase());
      }
      index += 1;
      index += 1;
      if (!isOk) isOk = index > 10;
    }
    if (!roles) return false;
    let flag: boolean = false;
    roles.forEach((x) => {
      if (flag) return flag;
      if (x.Access != null) {
        let accessList = JSON.parse(x.Access) as MvcAreaInfo[];
        if (
          accessList &&
          accessList.some((a) =>
            a.Controllers.some((c) =>
              c.Actions.some((a) =>
                createactionId && editactionId
                  ? a.Id === createactionId || a.Id === editactionId || a.Id === deleteactionId
                  : a.Id === actionId || a.Id === deleteactionId || a.Id === viewactionId
              )
            )
          )
        ) {
          flag = true;
          return flag;
        }
      } else flag = false;
    });
    return flag;
  }

  getCurrentUser() {
    return this.authService.currentUser;
  }
}
